/*
	Підключаєм тільки ті стилі, які будуть на всіх сторінках
*/
require('__scss/grid.scss');							// сітка
require('__scss/text.scss');							// стилі тектсу
require('__scss/fonts.scss');							// шрифти
require('__scss/animate.scss');
require('__scss/awesome.scss');						// іконци
require('__scss/jquery.fancybox.scss');			// стилі фансібокса
require('__scss/perfect-scrollbar.min.scss'); 	// perfect scrollbar

window.$ = window.jQuery = require('jquery');
window.$.fancybox = $.fancybox;


/*
	Підключаєм тільки ті модулі, які беруть участь в логіці всіх сторінок
*/
require('fancybox')($);

require('perfect-scrollbar/jquery')($);




window.ScrollMagic = require('ScrollMagic');
require('debug').addIndicators;

module.exports = (array) => {
	// console.log(array);

	if(array && array.length) {
		window.VueInstances = {};

		Vue.use(VueResource);

		array.map(component => {
			Vue.component(component, require(`__components/${component}.vue`));
			window.VueInstances[component] = {};
		})

		const components = document.querySelectorAll('[is]');

		// шукаєм всі діви із атрибутом "is" та запускаєм компоненти
		for(let i = 0; i < components.length; i++) {

			// перевіряєм, чи включений компонент в процес збірки проекту
			if(window.VueInstances[components[i].getAttribute('is')]) {
				if(components[i].getAttribute('data-params')) {

					let str = components[i].getAttribute('data-params');

					str = str.replace(/'/g, '"');

					try {
						// console.log("String to parse: ", str);
						let params = JSON.parse(str);

						window.VueInstances[components[i].getAttribute('is')][params.template] = new Vue({ el: components[i] });
					}

					catch (e) {
						console.log('Error when running Vue components! Bad params!');
						console.log(e);
					}
				}
				else {
					console.warn('dataParams is no defined', components[i]);
				}
			}
			else {
				console.warn(`Component ${components[i].getAttribute('is')} is not enabled, but used! Check module constructor options.`);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./libs/ModuleConstructor.js